import { Site } from '@debbie/common/dist/index.js';
import { isAdmin } from '@debbie/common/dist/permissions/index.js';
import { PropertyDataType, } from '@debbie/common/dist/properties/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as files from '@debbie/cortex/dist/api/files.js';
import { c } from '@debbie/cortex/dist/index.js';
import { useRole } from '@debbie/cortex/dist/me/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import AlignJustify from '../Icons/AlignJustify.js';
import Clock from '../Icons/Clock.js';
import EditIcon from '../Icons/Edit.js';
import Info from '../Icons/Info.js';
import ThumbsUp from '../Icons/ThumbsUp.js';
import { AddressInput, DateInput, File, Input, Loading, Modal, MoneyInput, Textarea, Well, } from '../index.js';
import PropertyHistory from './PropertyHistory.js';
import PropertyTypeInfo from './PropertyTypeInfo.js';
import PropertyValueInput from './PropertyValueInput.js';
let tId; // NodeJS.Timer
const PropertyCmp = (props) => {
    const { updateProperty: _updateProperty } = props;
    const site = useSelector((s) => s.site);
    const lang = useSelector((s) => s.lang);
    const meRole = useRole();
    const tenant = useTenant();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    useEffect(() => {
        setData(props.property?.data);
    }, [props.property]);
    const onToggle = () => {
        setModalOpen(!modalOpen);
    };
    const updateProperty = async (c) => {
        setLoading(true);
        try {
            await _updateProperty({
                data: c.data,
            });
        }
        catch (error) {
            console.error(error);
            alert(error || 'Error updating property');
        }
        setLoading(false);
        setDone(true);
        setTimeout(() => setDone(false), 2000);
    };
    const getProperty = () => {
        {
            switch (props.propertyType.type) {
                case PropertyDataType.checkbox:
                case PropertyDataType.dropdown:
                    return (React.createElement(PropertyValueInput, { showCheckboxLabel: false, propertyType: { ...propertyType, type: props.propertyType.type }, value: typeof data === 'boolean' || typeof data === 'string'
                            ? data
                            : null, disabled: !props.editable, onChange: (value) => {
                            setData(value);
                            void updateProperty({ data: value });
                        } }));
                case PropertyDataType.address:
                    return (React.createElement("div", null,
                        React.createElement(AddressInput, { address: data, disabled: !props.editable, onChange: (address) => {
                                setData(address);
                                updateProperty({
                                    data: address,
                                });
                            } })));
                case PropertyDataType.datePicker:
                    return (React.createElement(DateInput, { placeholder: propertyType.label, onChange: (date) => {
                            const _date = date ? moment(date).format() : null;
                            setData(_date);
                            updateProperty({
                                data: _date,
                            });
                        }, value: typeof data === 'string' ? moment(data) : null, allowNull: true, disabled: !props.editable }));
                case PropertyDataType.file:
                    return (React.createElement("div", null,
                        React.createElement(Dropzone, { disabled: !props.editable || dropFile.isLoading, acceptStyle: {
                                backgroundColor: 'grey',
                            }, className: "dropzone", 
                            // @ts-expect-error
                            onDrop: (acceptedFiles) => dropFile.mutate(acceptedFiles) }, lang.inputs.dropToUpload),
                        data?.fileId && (React.createElement("div", null,
                            React.createElement(File
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                file: data, onRemove: () => {
                                    setData(null);
                                    updateProperty({
                                        data: null,
                                    });
                                }, removable: true })))));
                case PropertyDataType.money:
                    return (React.createElement(MoneyInput, { disabled: !props.editable, placeholder: `${propertyType.label} [${data?.currency ? data.currency : ''}]`, value: data && typeof data.amount === 'number' ? data.amount : null, allowNull: true, onChange: (money) => {
                            const moneyData = {
                                amount: money,
                                currency: data?.currency || tenant?.currency,
                            };
                            setData(moneyData);
                            if (typeof money === 'number') {
                                clearTimeout(tId);
                                tId = setTimeout(() => {
                                    updateProperty({
                                        data: { amount: money, currency: data?.currency },
                                    });
                                }, props.newEntity ? 0 : 600);
                            }
                        } }));
                case PropertyDataType.singleLineText:
                    return (React.createElement(Input, { disabled: !props.editable, placeholder: propertyType.label, value: typeof data === 'string' ? data : '', onChange: (e) => {
                            const { value } = e.target;
                            setData(value);
                            if (props.newEntity) {
                                updateProperty({
                                    data: value ? value : null,
                                });
                            }
                        }, onSubmit: data !== props.property?.data && !props.newEntity
                            ? () => {
                                updateProperty({
                                    data: data ? data : null,
                                });
                            }
                            : undefined }));
                case PropertyDataType.multiLineText:
                    return (React.createElement(Textarea, { disabled: !props.editable, value: typeof data === 'string' ? data : '', style: { marginBottom: '0 !important' }, placeholder: propertyType.label, onChange: (e) => {
                            const { value } = e.target;
                            const val = value ? value : null;
                            setData(val);
                            clearTimeout(tId);
                            tId = setTimeout(() => {
                                updateProperty({
                                    data: val,
                                });
                            }, props.newEntity ? 0 : 600);
                        } }));
                case PropertyDataType.number:
                    return (React.createElement(Input, { disabled: !props.editable, placeholder: propertyType.label, type: "number", value: ['string', 'number'].includes(typeof data) ? `${data}` : '', onChange: (e) => {
                            const { value } = e.target;
                            setData(value);
                            const val = value && !Number.isNaN(parseFloat(value))
                                ? parseFloat(value)
                                : null;
                            clearTimeout(tId);
                            tId = setTimeout(() => {
                                updateProperty({
                                    data: val,
                                });
                            }, props.newEntity ? 0 : 600);
                        } }));
                default:
                    return React.createElement("div", null);
            }
        }
    };
    const dropFile = useMutation((acceptedFiles) => onDrop(acceptedFiles), {
        onSuccess: (newData) => setData(newData),
        onError: (err) => errorNotification(lang, err, 'create', lang.errorEntities.file),
    });
    const onDrop = async (acceptedFiles) => {
        const file = acceptedFiles[0];
        const fileReaded = (await promiseFileReader(file)).split('base64,')[1];
        if (file && fileReaded) {
            const res = await files.save({
                name: file.name,
                contentType: file.type,
                content: fileReaded,
            });
            await updateProperty({
                data: { ...res.file, fileName: file.name || 'file' },
            });
            return res.file;
        }
        else {
            alert('Error');
            return null;
        }
    };
    const promiseFileReader = async (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (event) => {
                resolve(event.target.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };
    const { propertyType } = props;
    return (React.createElement(PropertyStyled, null,
        React.createElement("div", null,
            React.createElement("span", { className: "label" },
                props.draggable && (React.createElement(AlignJustify, { style: {
                        fontSize: '1.3em',
                        margin: '0.2em 0.4em -0.2em 0',
                    } })),
                propertyType.label,
                propertyType.required && '*'),
            React.createElement("span", { className: "description" }, !props.newEntity && (React.createElement(React.Fragment, null,
                site === Site.Caseworker && !(loading || done) ? (React.createElement(Clock, { style: {
                        marginRight: '4px',
                    }, "data-tooltip-content": lang.properties.historical, "data-tooltip-id": "tooltip-default", onClick: onToggle })) : (React.createElement(React.Fragment, null, done ? (React.createElement(ThumbsUp, { style: {
                        marginRight: '4px',
                    } })) : (React.createElement("span", { style: {
                        marginRight: '4px',
                    } }, loading && React.createElement(Loading, { width: "13px" }))))),
                React.createElement(Info, { "data-tooltip-content": `${propertyType.description}
[${propertyType.handle}]`, "data-tooltip-id": "tooltip-default", style: { cursor: 'pointer' }, onClick: () => setInfoModalOpen(!infoModalOpen) }))))),
        React.createElement("div", { className: "content" }, getProperty()),
        site === Site.Caseworker && modalOpen && props.property?.refId && (React.createElement(PropertyHistory, { onToggle: onToggle, property: {
                propRef: props.propertyType.ref,
                propRefId: props.property?.refId,
                handle: props.propertyType.handle,
            } })),
        site === Site.Caseworker && infoModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setInfoModalOpen(!infoModalOpen), header: React.createElement(React.Fragment, null,
                "Info",
                ' ',
                meRole && isAdmin(meRole) && (React.createElement(EditIcon, { style: { float: 'none', height: '0.7em', cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/settings/case-config/properties/${props.propertyType.propertyTypeId}`) }))) },
            React.createElement("h3", null, lang.properties.description),
            React.createElement(Well, null, propertyType.description),
            React.createElement("h3", null, lang.properties.handle),
            React.createElement(Well, null, propertyType.handle),
            React.createElement("h3", null, lang.properties.usage),
            React.createElement(Well, null,
                React.createElement(PropertyTypeInfo, { property: propertyType }))))));
};
export default PropertyCmp;
const PropertyStyled = styled.div `
  .label {
    font-weight: bold;
    font-size: 0.8em;
    text-transform: uppercase;
  }

  .description {
    float: right;
  }

  .content {
    margin: 8px 0;
    font-size: 1.3em;
  }

  .dropzone {
    background-color: ${THEME.COLOR_SECONDARY};
    padding: 20px 15px 20px 15px;
    text-align: center;
    margin-bottom: 20px;
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    box-sizing: border-box;
    color: #cccccc;
    font-size: 0.7em;
  }
`;
//# sourceMappingURL=Property.js.map